<template>
<div fillHeight="lastHeight">
	<!-- <ViewDetail ref="ViewDetail" :type="1" :bg="true" v-if="deveceDetial" :timezone="timezone"></ViewDetail> -->
	<Confirm ref="confirmDel" @confirm="del"></Confirm>
	<AddChildSys ref="AddChildSys" @refreshChildSys="refresh()" @update="update"></AddChildSys>
	<div class="pt1x pl1x pb1x pr1x slectTag vaM_E">
		<Select :name="'searchState'" class="sizeM ml1x mr1x bgWhite" :list="allState" @Click="stateSelect" :bindActive="active.deviceState" :keyMap="{text:'name',value:'value'}"></Select>
		<InputText class="w20x dpIB" v-model="searchKey" :placeholder="getLanguageStr('phrase850','输入设备名称/序列号')" name="partSearchKey" :clearBtn="true" ref="searchBox" :searchBtn="true" :fn="searchList" @AfterClear="afterClear"></InputText>
		<div class="hasDropList-hover bdSub fR ml1x boxR lh20 pl05x pr05x hover-main tra-fast" v-permissions="'A/B/A8'" permission-type="none" v-if="doPermissions('A/B/A8',{targetCode:'A4',codeList:clone(roleCode)})">
			{{getLanguageStr('word1779','添加新网关/采集器')}}
			<div class="dropList dropList-right bgContent cMainContent hover-bg-highLight_E">
				<button @click="$emit('showDevices',node.id,level)" >{{getLanguageStr('word1779','添加新网关/采集器')}}</button>
				<button @click="$emit('editConnectDevices',node.id,level)">{{getLanguageStr('word1753','添加新子设备')}}</button>
			</div>
		</div>
	</div>
	<div class="tableSys" fillHeight="lastHeight,-.slectTag">
		<div class="w20x bgWhite bdSub-right posR">
			<Loading ref="Loading" v-show="loading"></Loading>
			<v-tree ref="tree" :data='treeData' v-show="treeData.length" :multiple='false' :halfcheck="false" @node-click="nodeClick"/>
		</div>
		<div class="bgContent">
				<div class="clearfix pl1x pr1x pt1x pb1x bdSub-bottom">
				<span class="fs14x" >{{node.name}}</span>
				<button class="fR bdSub boxR pl1x pr1x sizeS" onclick="statistic('A31','A3106')" :title="getLanguageStr('plant_detail114','添加子系统')" v-if="level==0 && doPermissions('A/B/A8',{targetCode:'A4',codeList:clone(roleCode)})" @click="_AddChildSys()" v-permissions="'A/B/A8'" permission-type="none">{{getLanguageStr('plant_detail114','添加子系统')}}</button>
				<button class="fR bdSub boxR pl1x pr1x sizeS" :title="getLanguageStr('cmd9','删除')" v-if="level==1 && doPermissions('A/B/A10',{targetCode:'A6',codeList:clone(roleCode)})" @click="_delChildSys()" v-permissions="'A/B/A10'" permission-type="none">{{getLanguageStr('cmd9','删除')}}</button>
				<button class="fR bdSub boxR pl1x pr1x sizeS mr1x" :title="$t('fill3rd143',[getLanguageStr('word1487'),'编辑子系统'])" v-if="level==1 && doPermissions('A/B/A9',{targetCode:'A5',codeList:clone(roleCode)})" @click="_EditChildSys()" v-permissions="'A/B/A9'" permission-type="none">{{$t('fill3rd143',[getLanguageStr('word1487'),'编辑子系统'])}}</button>
			</div>
			<div>
				<div class="navBtn pl1x bdSub-bottom" v-if="btnGroup_equipment.length>0">
					<div class="tabBar style-tabBar cb active-c-main_E tra-fast_E mt0x">
						<template v-for="(item,index) in btnGroup_equipment">
							<button :key="index" class="cSub" :class="{active:index==deviceIndex}" @click="changeTab(index)">{{item.title}}</button>
						</template>
					</div>
				</div>
				<div class="tableScope bgContent">
					<InverterList v-if="btnGroup_equipment.length && btnGroup_equipment[deviceIndex].childRef=='InverterList'" :roleCode="roleCode" :stationId="stationId" @refreshTree="refreshTree" ref="InverterList"></InverterList>
					<AmmeterList v-if="btnGroup_equipment.length && btnGroup_equipment[deviceIndex].childRef=='AmmeterList'" :roleCode="roleCode" :stationId="stationId" @refreshTree="refreshTree" ref="AmmeterList"></AmmeterList>
					<ComponetList v-if="btnGroup_equipment.length && btnGroup_equipment[deviceIndex].childRef=='ComponetList'" :roleCode="roleCode" :stationId="stationId" @refreshTree="refreshTree" ref="ComponetList"></ComponetList>
					<WeatherList v-if="btnGroup_equipment.length && btnGroup_equipment[deviceIndex].childRef=='WeatherList'" :roleCode="roleCode" :stationId="stationId" @refreshTree="refreshTree" ref="WeatherList"></WeatherList>
					<MicroInverterList v-if="btnGroup_equipment.length && btnGroup_equipment[deviceIndex].childRef=='MicroInverterList'" :roleCode="roleCode" :stationId="stationId" @refreshTree="refreshTree" ref="MicroInverterList"></MicroInverterList>
					<CombinerBoxList v-if="btnGroup_equipment.length && btnGroup_equipment[deviceIndex].childRef=='CombinerBoxList'" :roleCode="roleCode" :stationId="stationId" @refreshTree="refreshTree" ref="CombinerBoxList"></CombinerBoxList>
					<RepeaterList v-if="btnGroup_equipment.length && btnGroup_equipment[deviceIndex].childRef=='RepeaterList'" :roleCode="roleCode" :stationId="stationId" @refreshTree="refreshTree" ref="RepeaterList"></RepeaterList>
					<BatteryList v-if="btnGroup_equipment.length && btnGroup_equipment[deviceIndex].childRef=='BatteryList'" :roleCode="roleCode" :stationId="stationId" @refreshTree="refreshTree" ref="BatteryList"></BatteryList>
					<FANList v-if="btnGroup_equipment.length && btnGroup_equipment[deviceIndex].childRef=='FANList'" :roleCode="roleCode" :stationId="stationId" @refreshTree="refreshTree" ref="FANList"></FANList>
					<CollectorList v-if="btnGroup_equipment.length && btnGroup_equipment[deviceIndex].childRef=='CollectorList'" :roleCode="roleCode" :stationId="stationId" @refreshTree="refreshTree" ref="CollectorList"></CollectorList>
					<DTUList v-if="btnGroup_equipment.length && btnGroup_equipment[deviceIndex].childRef=='DTUList'" :roleCode="roleCode" :stationId="stationId" @refreshTree="refreshTree" ref="DTUList"></DTUList>
					<APIList v-if="btnGroup_equipment.length && btnGroup_equipment[deviceIndex].childRef=='APIList'" :roleCode="roleCode" :stationId="stationId" @refreshTree="refreshTree" ref="APIList"></APIList>
				</div>
			</div>
			<no-result v-show="btnGroupEmpty&&btnGroup_equipment.length==0"></no-result>
		</div>
	</div>
</div>
</template>
<script>
import AddChildSys from '@/components/common/ChildSysConfig.vue';
import Select from '@/components/common/ui/Select.vue';
import InputText from '@/components/common/ui/InputText.vue';
import ChildSysTable from '@/view/maintain/part/childSys/ChildSysTable';
import InverterList from '@/view/maintain/part/childSys/InverterList';// 逆变器
import AmmeterList from '@/view/maintain/part/childSys/AmmeterList'; // 电表列表
import ComponetList from '@/view/maintain/part/childSys/ComponetList'; // 组件列表
import WeatherList from '@/view/maintain/part/childSys/WeatherList'; // 气象列表
import CollectorList from '@/view/maintain/part/childSys/CollectorList'; // 采集器列表
import MicroInverterList from '@/view/maintain/part/childSys/MicroInverterList'; // 微逆列表
import CombinerBoxList from '@/view/maintain/part/childSys/CombinerBoxList'; // 汇流箱列表
import RepeaterList from '@/view/maintain/part/childSys/RepeaterList'; // 中继器列表
import BatteryList from '@/view/maintain/part/childSys/BatteryList'; // 电池列表
import DTUList from '@/view/maintain/part/childSys/DtuList'; // dtu列表
import APIList from '@/view/maintain/part/childSys/APIList'; // API列表
import FANList from '@/view/maintain/part/childSys/FANList'; // FAN列表
import Confirm from '@/components/common/ui/Confirm.vue';
import VTree from '@/components/common/ui/vTree/Tree';
import Loading from '@/components/common/ui/Loading';
import NoResult from '@/components/common/ui/NoResult';
import * as maintainApi from '@/api/maintain/plant/list';
import {getLanguageStr} from '@/util/language';
import DeviceDetail from '@/view/device/operationalAudit/ViewDetail.vue';
import * as tree from '@/util/vTree';
import {setStage, changeTreeDataToList} from '@/util/projectTree';
import * as lib from '@/util/lib';
export default {
	// name: 'ChildSys',
	components: {DeviceDetail, Select, InputText, ChildSysTable, VTree, Loading, AddChildSys, Confirm, InverterList, AmmeterList, ComponetList, WeatherList, CollectorList, MicroInverterList, CombinerBoxList, RepeaterList, BatteryList, DTUList, NoResult, APIList, FANList},
	props: {
		timezone: {
			type: String,
			default: ''
		},
		roleCode: {
			type: Array,
			default: () => { []; }
		}
	},
	data () {
		return {
			stationId: null,
			systemId: null,
			node: {},
			// isChild:false,
			treeData: [],
			AddDevicesShow: false,
			treeDataArr: [],
			name: '',
			level: 0,
			parentLevel: 0,
			active: {
				deviceState: null,
				alterStatus: null,
				sn: null
			},
			loading: true,
			allState: [
				{value: null, name: getLanguageStr('cmd19', '全部'), def: getLanguageStr('word166', '状态')},
				// {value: '0', name: getLanguageStr('word94', '未激活')},
				{value: '1', name: getLanguageStr('word1588', '在线')},
				{value: '2', name: getLanguageStr('plant_alert59', '报警')},
				{value: '3', name: getLanguageStr('word64', '离线')}],
			//    alarmState: [{
			//      text: getLanguageStr('word1651', '全部报警状态'),
			//      value: null
			//    }, {
			//      text: getLanguageStr('word1969', '有报警设备'),
			//      value: 1
			//    }, {
			//      text: getLanguageStr('word1970', '无报警设备'),
			//      value: 0
			//    }],
			btnGroup_equipment: [],
			deviceIndex: 0,
			btnGroupEmpty: false,
			deveceDetial: false,
			summaryTag: '',
			searchKey: '',
			delIndexName: ''
			// btnGroup_equipment:[]
		};
	},
	watch: {
	},
	mounted () {
		lib.fillHeight();
	},
	methods: {
		getLanguageStr,
		doPermissions: lib.doPermissions,
		clone (arr) {
			return _.cloneDeep(arr);
		},
		show (data) {
			this.deviceIndex = 0;
			if (data.tag) { // 记录系统概跳转信息
				this.summaryTag = data.tag;
			}
			this.AddDevicesShow = false;
			this.stationId = data.stationId;
			this.systemId = data.systemId;
			this.parentLevel = data.level;
			this.level = _.cloneDeep(data.level);
			if (data.level == 0) {
				this._getHeadInfo(data.stationId);
				this._getSummary(this.stationId, null);
			} else {
				this._getHeadInfo(data.systemId);
				this._getSummary(this.stationId, this.systemId);
			}
			if (data.hasOwnProperty('deviceState')) { // 如果有状态
				this.active.deviceState = data.deviceState;
			}
		},
		_getSummary (id, sysId) {
			// this.result={}
			this.btnGroupEmpty = false;
			maintainApi.StationSummary(id, {systemId: sysId}).then(res => {
				const {collectorCount, inverterCount, meterCount, pvModuleCount, weatherStationCount, microInverterCount, combinerBoxCount, repeaterCount, batteryCount, dtuCount, apiCount, fanCount} = res;
				const btnState = [
					{title: getLanguageStr('word35', '逆变器'), api: 'OperationInverter', childRef: 'InverterList', count: inverterCount && inverterCount.total ? inverterCount.total : 0},
					{title: getLanguageStr('word39', '电表'), api: 'OperationAmmeter', childRef: 'AmmeterList', count: meterCount.total},
					{title: getLanguageStr('word647', '组件'), api: 'OperationComponet', childRef: 'ComponetList', count: pvModuleCount ? (pvModuleCount.total || 0) : 0},
					{title: getLanguageStr('word38', '气象站'), api: 'OperationWeather', childRef: 'WeatherList', count: weatherStationCount.total},
					{title: getLanguageStr('word804', '微逆'), api: 'OperationMicroInverter', childRef: 'MicroInverterList', count: microInverterCount.total},
					{title: getLanguageStr('word36', '汇流箱'), api: 'OperationCombinerBox', childRef: 'CombinerBoxList', count: combinerBoxCount.total},
					{title: getLanguageStr('word803', '中继器'), api: 'OperationRepeater', childRef: 'RepeaterList', count: repeaterCount.total},
					{title: getLanguageStr('word37', '电池'), api: 'OperationBattery', childRef: 'BatteryList', count: batteryCount.total},
				 {title: getLanguageStr('plant240', '风机'), api: 'OperationFAN', childRef: 'FANList', count: fanCount.total},
					{title: getLanguageStr('word34', '采集器'), api: 'OperationCollector', childRef: 'CollectorList', count: collectorCount.total},
					{title: getLanguageStr('DTU', 'DTU'), api: 'OperationDTU', childRef: 'DTUList', count: dtuCount.total},
					{title: getLanguageStr('API', 'API'), api: 'OperationAPI', childRef: 'APIList', count: apiCount && apiCount.total ? apiCount.total : 0}
				];
				this.btnGroup_equipment = btnState.filter(el => el.count > 0);
				if (this.btnGroup_equipment.length > 0) {
					this.btnGroupEmpty = false;
					if (this.summaryTag) { // 如果是系统概要跳转
						this.btnGroup_equipment.forEach((val, index) => {
							if (val.childRef == this.summaryTag) {
								this.deviceIndex = index;
							}
						});
					} else {
						let childRefArr = this.btnGroup_equipment.map((item, index) => {
							return item.childRef;
						});
						let pos = childRefArr.indexOf(this.delIndexName);
						if (pos > -1) {
							this.deviceIndex = pos;
						} else {
							this.deviceIndex = 0;
						}
					}
					this.changeTab(this.deviceIndex);
				} else {
					this.btnGroupEmpty = true;
				}
			 lib.fillHeight();
			}, error => {
				this.isLoading = false;
				!_.isEmpty(error) && this.$notify(error);
			});
		},
		// 头部信息
		_getHeadInfo (id, endFn) {
			this.treeData = [];
			this.loading = true;
			maintainApi.StationStructure(id).then(res => {
				this.loading = false;
				this.treeDataArr = changeTreeDataToList([res]); // 把返回值换成扁平结构后重新组装（目的：返回之中children字段会有null,去除null）
				this.treeDataArr.forEach((data, index) => {
					this.$set(data, 'selected', false);
					this.$set(data, 'expanded', true);
					this.$set(data, 'title', `${data.name}(${data.deviceNum}${getLanguageStr('word164', '设备')})`);
				});
				if (this.systemId != this.stationId && this.systemId && this.parentLevel != 0) { // 子系统的设备tab
					this.treeDataArr.forEach((data, index) => {
						if (data.id == this.systemId) {
							this.$set(data, 'selected', true);
							this.node = _.cloneDeep(data);
							this.level = this.node.level;
						}
					});
				} else { // 主系统的设备tab
					this.treeDataArr.forEach((data, index) => {
						if (data.id == this.stationId) {
							this.$set(data, 'selected', true);
							this.node = _.cloneDeep(data);
							this.level = this.node.level;
						}
					});
				}
				let arr = tree.toTree(this.treeDataArr);
				this.treeData = _.cloneDeep(arr);
				if (endFn) endFn();
			}, error => {
				this.loading = false;
				!_.isEmpty(error) && this.$notify(error);
			});
		},
		nodeClick (node) {
			this.deviceIndex = 0;
			this.level = node.level;
			this.node = node;
			if (this.level == 0) {
				this.systemId = this.stationId;
				this._getSummary(this.stationId, null);
			} else {
				this.systemId = node.id;
				this._getSummary(this.stationId, this.systemId);
			}
		 // this.changeTab(this.deviceIndex)
		},
		// 状态筛选
		stateSelect (index) {
			this.active.deviceState = this.allState[index].value;
			this.changeTab(this.deviceIndex);
			//  this.$refs.table.show({
			//     stationId:this.stationId,
			//     systemId:this.systemId,
			//     level:this.level,
			//     status:this.active
			// })
		},
		// 报警状态筛选
		//  AlertStateSelect (index) {
		//    this.active.alterStatus = this.alarmState[index].value
		//    this.changeTab(this.deviceIndex)
		//  this.$refs.table.show({
		//     stationId:this.stationId,
		//     systemId:this.systemId,
		//     level:this.level,
		//     status:this.active
		// })
		//  },
		searchList () {
			this.active.sn = this.searchKey;
			this.changeTab(this.deviceIndex, 1);
		},
		afterClear () {
			if (this.active.sn) this.searchList();
		},
		_BtnGroup (data) {
			this.btnGroup_equipment = data;
		},
		changeTab (index, page) {
			if (this.btnGroup_equipment.length > 0) {
				this.delIndexName = this.btnGroup_equipment[index].childRef;
			}
			this.deviceIndex = index;
			this.$nextTick(() => {
				if (this.btnGroup_equipment.length) {
					this.$refs[this.btnGroup_equipment[this.deviceIndex].childRef].show({stationId: this.stationId, systemId: this.systemId, level: this.level, status: this.active, timeOffset: this.timezone, page: page});
				}
			});
		},
		// 添加子系统
		_AddChildSys () {
			this.$refs.AddChildSys.modeChange('new');
			this.$refs.AddChildSys.show({
				id: this.stationId
			});
		},
		// 编辑子系统
		_EditChildSys (data) {
			this.$refs.AddChildSys.modeChange('edit');
			this.$refs.AddChildSys.show({
				node: this.node
			});
		},
		// 删除子系统
		_delChildSys () {
			this.$refs.confirmDel.show({
				text: getLanguageStr('phrase640', '确定要删除子系统吗？这将导致子系统所有历史数据丢失，请谨慎操作！')
			});
		},
		del () {
			maintainApi.DeleteChildSys(this.node.id).then(res => {
				if (this.parentLevel == 0) {
					this._getHeadInfo(this.stationId);
				}
				this.$emit('refrshDetail');
			}, error => {
				!_.isEmpty(error) && this.$notify(error);
			});
		},
		// 刷新树结构并抛出事件刷新父页的头部信息
		refresh () {
			if (this.parentLevel == 0) {
				this._getHeadInfo(this.stationId);
				this.$emit('refrshDetail');
			} else {
				this._getHeadInfo(this.systemId);
				this.$emit('addChildSysSuccess');
			}
			this.$refs[this.btnGroup_equipment[this.deviceIndex].childRef].show({stationId: this.stationId, systemId: this.systemId, level: this.level, status: this.active, timeOffset: this.timezone, page: 1});
		},
		update () {
			this._getHeadInfo(this.stationId);
			this.$emit('refreshSelect');
		},
		// 删除设备后刷新左侧树
		refreshTree () {
			if (this.parentLevel == 0) {
				this._getHeadInfo(this.stationId);
				this._getSummary(this.stationId, null);
			} else {
				this._getHeadInfo(this.systemId);
				this._getSummary(this.stationId, this.systemId);
			}
		},
		// viewDetail (device) {
		//   let buttonPermissions = JSON.parse(localStorage.getItem('buttonPermissions'))
		//   if (buttonPermissions.includes('B/A/A5')) {
		//     this.deveceDetial = true
		//     this.$nextTick(() => {
		//         this.$dynamic($(this.$el).parents("#app").find(".frame-main section").first()[0],DeviceDetail,{bg:true,type:1},{
		//           'closePage': [],
		//           'refresh': [],
		//           'update': [],
		//           'showStations': [],
		//           'DeviceControls': [],
		//           'DeviceUpgrades': [],
		//           'Dels': []
		//         },{}).then(({ instance, childInstance }) => {
		//           // console.log(device)
		//           device.activationState = device.deviceState == 0 ? 0 : 1
		//           childInstance.show({...device, siteId: this.stationId, deviceId: device.id}, '', instance, device.name);
		//         });
		//     //  this.$refs.ViewDetail.show({siteId: this.stationId, deviceId: device.id}, '', '', '', '', device.name)
		//     })
		//   } else {
		//     this.$notify(getLanguageStr('phrase783', '你没有权限，请联系本商家超级管理员开启'))
		//   }
		// },
		// 树状子系统添加直连设备后刷新
		refreshDevice () {
			this.refreshTree();
			this.changeTab(this.deviceIndex);
		}
	}

};
</script>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/part/ChildSys.vue